// import { _converse, converse, api, log } from '@converse/headless';
// import BaseModal from 'plugins/modal/modal.js';
// import tplAddContactModal from './templates/add-contact.js';
// import { __ } from 'i18n';

// const { Strophe } = converse.env;

// import './styles/add-contact.scss';

// export default class AddContactModal extends BaseModal {
//     constructor() {
//         super();
//         this.contact = null;
//     }

//     initialize() {
//         super.initialize();
//         this.listenTo(this.contact, 'change', () => this.requestUpdate());
//         this.requestUpdate();
//         this.addEventListener(
//             'shown.bs.modal',
//             () => /** @type {HTMLInputElement} */ (this.querySelector('input[name="jid"]'))?.focus(),
//             false
//         );
//     }

//     renderModal() {
//         return tplAddContactModal(this);
//     }

//     getModalTitle() {
//         return __('Add a Contact');
//     }

//     /**
//      * @param {string} jid
//      */
//     validateSubmission(jid) {
//         if (!jid || jid.split('@').filter((s) => !!s).length < 2) {
//             this.alert(__('Please enter a valid XMPP address'), 'danger', false);
//             return false;
//         } else if (!this.contact && _converse.state.roster.get(Strophe.getBareJidFromJid(jid))) {
//             this.alert(__('This contact has already been added'), 'danger', false);
//             return false;
//         }
//         this.alert(null); // Clear the alert
//         return true;
//     }

//     /**
//      * @param {string} jid
//      * @param {string} name
//      * @param {string[]} groups
//      */
//     async afterSubmission(jid, name, groups) {
//         api.contacts.add({ jid, name, groups }).catch((e) => {
//             log.error(e);
//             api.toast.show('contact-add-error', {
//                 type: 'danger',
//                 body: __('Sorry, something went wrong while adding the contact'),
//             });
//             return;
//         });
//         api.chats.open(jid, {}, true);
//         this.alert(null); // clear alert
//         api.toast.show('contact-added', { type: 'success', body: __('Contact added successfully') });
//         this.modal.hide();
//     }

//     /**
//      * @param {Event} ev
//      */
//     async addContactFromForm(ev) {
//         ev.preventDefault();
//         const form = /** @type {HTMLFormElement} */ (ev.target);
//         const data = new FormData(form);
//         let jid = /** @type {string} */ (data.get('jid') || '').trim();

//         let name;
//         if (api.settings.get('xhr_user_search_url')) {
//             // In this case, the value of `jid` is something like `John Doe <john@chat.com>`
//             // So we want to get `name` which is `John Doe` and reset `jid` to
//             // what's inside the arrow brackets, so in this case
//             // `john@chat.com`.
//             const match = jid.match(/^(.*) <(.*)>$/);
//             if (match) {
//                 name = match[1].trim();
//                 jid = match[2].trim();
//             } else {
//                 this.alert(
//                     __(
//                         'Invalid value for the name and XMPP address. Please use the format "Name <username@example.org>".'
//                     ),
//                     'danger',
//                     false
//                 );
//                 return;
//             }
//         } else {
//             name = /** @type {string} */ (data.get('name') || '').trim();
//         }

//         if (this.validateSubmission(jid)) {
//             const groups =
//                 /** @type {string} */ (data.get('groups'))
//                     ?.split(',')
//                     .map((g) => g.trim())
//                     .filter((g) => g) || [];
//             this.afterSubmission(jid, name, groups);
//             form.reset();
//         }
//     }
// }

// api.elements.define('converse-add-contact-modal', AddContactModal);
import { _converse, converse, api, log } from '@converse/headless';
import BaseModal from 'plugins/modal/modal.js';
import tplAddContactModal from './templates/add-contact.js';
import { __ } from 'i18n';

// Повертаємо імпорт стилів!
import './styles/add-contact.scss';

const { Strophe } = converse.env;

export default class AddContactModal extends BaseModal {
    constructor() {
        super();
        this.contact = null;
        this.search_type = 'lastName';
        this.search_results = [];
        this.is_searching = false;
        this.search_timeout = null;
    }

    initialize() {
        super.initialize();
        this.requestUpdate();
    }

    renderModal() {
        return tplAddContactModal(this);
    }

    renderModalFooter() {
        return '';
    }

    getModalTitle() {
        return __('Add a Contact');
    }

    switchTab(ev, type) {
        ev.preventDefault();
        this.search_type = type;
        this.search_results = [];
        this.requestUpdate();
    }

    onSearchInput(ev) {
        const query = ev.target.value.trim();

        if (this.search_timeout) {
            clearTimeout(this.search_timeout);
        }

        if (query.length < 2) {
            this.search_results = [];
            this.is_searching = false;
            this.requestUpdate();
            return;
        }

        // Чекаємо 500мс після останнього символу
        this.search_timeout = setTimeout(() => {
            this.performSearch(query);
        }, 500);
    }

    async performSearch(query) {
        this.is_searching = true;
        this.requestUpdate();

        // Отримуємо домен та токен
        const domain = localStorage.getItem('s_selected_domain');
        // ВАЖЛИВО: використовуємо ключ 'temp_tokens', який ти вказав у логіці логіну
        const token = sessionStorage.getItem('s_token');

        const apiRoot = `https://api-admin-chat.${domain}/`;
        const url = `${apiRoot}/subscriber/search?${this.search_type}=${encodeURIComponent(query)}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 403 || response.status === 401) {
                log.error('Auth error: Invalid token');
                // Тут можна було б викликати refreshSonataToken(), якщо він доступний в області видимості
                this.search_results = [];
            } else if (response.ok) {
                const result = await response.json();
                this.search_results = result.data || [];
            } else {
                this.search_results = [];
            }
        } catch (e) {
            log.error('Search fetch error:', e);
        } finally {
            this.is_searching = false;
            this.requestUpdate();
        }
    }

    addSelectedContact(contact) {
        const domain = localStorage.getItem('s_selected_domain');

        // 1. Очищаем логин от возможных лишних символов (двоеточия, пробелы)
        // Если логин приходит как ":e.bondarev4", этот код сделает его "e.bondarev4"
        const cleanLogin = contact.login.replace(/^[:\s]+/, '');
        console.log(contact.number);
        // 2. Формуємо JID
        const jid = `${contact.number}@chat.${domain}`;
        const name = contact.fullName;

        console.log(`Attempting to add contact: ${jid}`); // Для отладки в консоли

        api.contacts
            .add({ jid, name })
            .then(() => {
                api.chats.open(jid, {}, true);
                this.modal.hide();
                api.toast.show('contact-added', { type: 'success', body: __('Contact added') });
            })
            .catch((e) => {
                log.error('Failed to add contact:', e);
                // Выводим текст ошибки пользователю, чтобы он не гадал
                api.toast.show('error', {
                    type: 'danger',
                    body: __('Could not add contact. Check JID format.'),
                });
            });
    }
}

api.elements.define('converse-add-contact-modal', AddContactModal);
